<template>
  <div class="guide-box flex flex-center">
    <div class="main-box flex flex-col">
      <div class="title-box">
        {{ fileType === 1 ? "申 报 指 南" : "文 件 下 载" }}
      </div>
      <div class="content-box flex-1">
        <div
          class="item-box flex align-items-center"
          v-for="(item, index) in fileList"
          :key="index"
        >
          <img class="img-box" :src="getImg(1)" alt="" />
          <div class="info-box flex-1">
            <div>{{ item.name }}</div>
            <div>{{ item.byte }}</div>
          </div>
          <div
            v-if="fileType == 1"
            class="preview-btn"
            @click="preview(item.name)"
          >
            <span class="preview">预 览</span>
          </div>
          <div class="download-btn">
            <span>
              <!-- <a
                v-if="fileType == 1"
                :href="`${path}${getFileName(
                  $store.state.region
                )}职业院校铸魂育人计划项目遴选-学校使用手册.pdf`"
                download
              >下 载</a> -->
              <a 
                v-if="fileType == 1 && city!=''" 
                :href="`${path}${city}职业院校技能大赛教学能力比赛-学校使用手册.pdf`"
                download
              >下 载</a>
               <a 
                v-if="fileType == 1 && city==''" 
                :href="`${path}金石榴网络育人创新联盟平台-学校使用手册.pdf`"
                download
              >下 载</a>
              <a v-if="fileType == 2" :href="`${path}${item.name}`" download>下 载</a>
              </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {roleFilterText,roleFilterFile} from "@/utils/roleFilter.js"
export default {
  name: "",
  components: {},
  props: {
    fileType: {
      type: Number,
      default: 1,
    },
    fileList: Array,
  },
  data() {
    return {
      path: process.env.BASE_URL,
      city: roleFilterText(this.$store.state.region),
      roleFilterFile:roleFilterFile()
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    // this.city = roleFilterText(this.$store.state.region)
  },
  methods: {
    // getFileName(type) {
    //   if (type === 1) {
    //     return "吕梁市";
    //   } else if (type === 2) {
    //     return "临汾市";
    //   } else {
    //     return "长治市";
    //   }
    // },
    getImg(type) {
      if (type === 1) {
        return require("../assets/images/img3.png");
      } else {
        return require("../assets/images/img2.png");
      }
    },
    preview() {
    	if(this.city!=''){
    		  window.open(
	        `${this.path}${this.city}职业院校技能大赛教学能力比赛-学校使用手册.pdf`,
	        "_blank"
	      );
    	}else{
    		 window.open(
	        `${this.path}金石榴网络育人创新联盟平台-学校使用手册.pdf`,
	        "_blank"
	      );
    	}
    
      // if (this.$store.state.region === 1) {
      //   window.open(
      //     `${this.path}吕梁市职业院校铸魂育人计划项目遴选-学校使用手册.pdf`,
      //     "_blank"
      //   );
      // } else if (this.$store.state.region === 2) {
      //   window.open(
      //     `${this.path}临汾市职业院校铸魂育人计划项目遴选-学校使用手册.pdf`,
      //     "_blank"
      //   );
      // } else {
      //   window.open(
      //     `${this.path}长治市职业院校铸魂育人计划项目遴选-学校使用手册.pdf`,
      //     "_blank"
      //   );
      // }
    },
    // download() {
    //   window.open(`${this.path}《${this.city}市教育局关于举办2022年职业院校技能大赛班主任能力比赛的通知》长教办函2022 108号.PDF.pdf`, "_blank");
    // },
  },
};
</script>

<style scoped lang="scss">
.main-box {
  width: 100%;
  height: 100%;
  border-radius: 10px;
}
.title-box {
  height: 60px;
  line-height: 60px;
  font-size: 27px;
  font-family: Microsoft YaHei;
  text-align: center;
  font-weight: bold;
  background: #dde8ff;
  color: #000000;
}
.content-box {
  background: #fff;
  overflow: auto;
  padding: 33px 40px;
  padding-top: 10px;
}
.item-box {
  height: 84px;
  padding: 0 34px;
  margin-top: 23px;
  background: url("../assets/images/img15.png") no-repeat;
  background-size: 100% 100%;
}
.img-box {
  width: 52px;
  height: 52px;
}
.info-box {
  margin-left: 20px;
}
.info-box div:nth-child(1) {
  font-size: 19px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #000000;
}
.info-box div:nth-child(2) {
  font-size: 15px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #a28e8a;
}
.preview-btn {
  width: 100px;
  height: 33px;
  line-height: 33px;
  text-align: center;
  background: #edf3fe;
  border: 1px solid #5d99ff;
  font-size: 17px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #9A0B00;
  border-radius: 20px;
  margin-right: 20px;
  cursor: pointer;
}
.download-btn {
  width: 100px;
  height: 33px;
  line-height: 33px;
  text-align: center;
  background: #edf3fe;
  border: 1px solid #5d99ff;
  font-size: 17px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #9A0B00;
  border-radius: 20px;
  cursor: pointer;
  a {
    color: #9A0B00;
  }
}
// .preview-btn:hover {
//   color: #ffffff !important;
//   background: linear-gradient(to right, #b91000, #d41400);
//   cursor: pointer;
// }
// .download-btn:hover {
//   color: #ffffff !important;
//   background: linear-gradient(to right, #b91000, #d41400);
//   cursor: pointer;
//   a {
//     color: #ffffff !important;
//   }
// }
.item-box:hover {
  background: url("../assets/images/img12.png") no-repeat;
  background-size: 100% 100%;
}
</style>
